import { gatewayPhone } from "../../../../gateways/gatewayPhone";
import { InboundType } from "../../contacts/enums/inbound.enums";
import { SmsContact } from "../contacts/types/SmsContact";

export interface PaginatedSmsContactsResponse {
  data: SmsContact[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

interface FetchSmsContactsParams {
  from: string;
  page?: number;
  limit?: number;
}

export const fetchSmsContacts = async ({
  from,
  page = 1,
  limit = 20,
}: FetchSmsContactsParams): Promise<PaginatedSmsContactsResponse> => {
  const { data } = await gatewayPhone.get<PaginatedSmsContactsResponse>(
    "/inbound-records/contacts",
    {
      params: {
        fromNumber: from,
        type: InboundType.MESSAGE,
        page,
        limit,
      },
    }
  );

  if (!data || !Array.isArray(data.data)) {
    return {
      data: [],
      meta: {
        page,
        limit,
        total: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
      },
    };
  }



  return data;
};